import { render } from "./Main.vue?vue&type=template&id=5a7e1b3d"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=5a7e1b3d&lang=scss"
script.render = render

export default script